import domPlugin from '@ricoh/ria.client.core/plugins/app/dom';
import esPlugin from '@ricoh/ria.client.core/plugins/app/es';
import labPlugin from '@ricoh/ria.client.core/plugins/app/lab';
import loggerPlugin from '@ricoh/ria.client.core/plugins/app/logger';
import fontawesomePlugin from '@ricoh/ria.client.core/plugins/fortawesome';
import i18nPlugin from '@ricoh/ria.client.core/plugins/i18n';
import jqueryPlugin from '@ricoh/ria.client.core/plugins/jquery';

import axiosPlugin from '~/plugins/axios';
import app from '~/components/app';

const importStore = async () => (await import('~/plugins/store')).default;
const importServiceServerConfigBase = async () => (await import('./services/server/_config')).default;

/** Main entry point. */
(async function main() {
  loggerPlugin.init();
  esPlugin.init();

  await Promise.all([
    // Core
    domPlugin.init(),

    // Libraries
    axiosPlugin.init(),
    fontawesomePlugin.init(),
    jqueryPlugin.init(),
    i18nPlugin.init(),

    // Lab for development and debugging
    labPlugin.init(async () => {
      const [store, serviceServerConfigBase] = await Promise.all([importStore(), importServiceServerConfigBase()]);

      return {
        store,
        service: {
          server: axiosPlugin.createClient(serviceServerConfigBase.options(import.meta.env.APP_SERVER_BASE_WEB)),
        },
      };
    }),
  ]);

  app.render({
    reloadDocument: globalThis.location.pathname.startsWith('/analytics'),
  });
})();
